import React from 'react';

import HeroSection from '../components/HeroSection';
import EventDate from '../components/EventDate';
import Gallery from '../components/Gallery';
import Details from '../components/Details';
import Agenda from '../components/Agenda';
import RSVPForm from '../components/RSVPForm';
import GiftOptions from '../components/GiftOptions';
import Hotels from '../components/Hotels';
import FinalSection from '../components/FinalSection';

const Home: React.FC = () => (
  <>
    <HeroSection />
    <EventDate />
    <Gallery />
    <Details />
    <Agenda />
    <RSVPForm />
    <GiftOptions />
    <Hotels />
    <FinalSection />
  </>
);

export default Home;
